import { TypeInitProps, TypeRequest } from '../../../types';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class UserAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_id - encrypted user id
   * @param {string} name - user name
   * @param {number} identity_id - id of identity
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  createUserWithRole = (params: {
    role_key: string;
    sec_user_id: string;
    name: string;
    identity_id: number;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const {
      role_key,
      sec_user_id,
      name,
      identity_id,
      subject_uid,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CREATE_USER_WITH_ROLE,
        method: 'POST',
        data: {
          role_key,
          sec_user_id,
          name,
          identity_id,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} add result
   */
  addUserRole = (params: {
    role_key: string;
    sec_user_identity_ids: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const {
      role_key,
      sec_user_identity_ids,
      subject_uid,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.ADD_USER_ROLE,
        method: 'POST',
        data: {
          role_key,
          sec_user_identity_ids,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} delete result
   */
  deleteUserRole = (params: {
    role_key: string;
    sec_user_identity_ids: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const {
      role_key,
      sec_user_identity_ids,
      subject_uid,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.DELETE_USER_ROLE,
        method: 'POST',
        data: {
          role_key,
          sec_user_identity_ids,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  getUserRoleList = (params: {
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.USER_ROLE_LIST,
        method: 'GET',
        data: {
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} subject_uid - id of subject
   * @param {number} identity_id - id of identity
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  getAllUserRoleList = (params: {
    subject_uid: number;
    identity_id: number;
    page?: number;
    page_size?: number;
    extra_params?: object;
  }) => {
    const {
      subject_uid,
      identity_id,
      page = 1,
      page_size = 10,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: `${WEB_AFF_URL.ALL_USER_ROLE_LIST}${page}/`,
        method: 'GET',
        data: {
          subject_uid,
          identity_id,
          page_size,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  getUserPermissions = (params: {
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.USER_PERMISSIONS,
        method: 'GET',
        data: {
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
